import type { ReactNode } from "react";
import { EmptyState, LoadingState } from "../../components/ui";
import {
  isPublicModuleEnabled,
  usePublicModuleVisibility,
} from "./useModuleVisibility";

export function PublicSectionGate({
  moduleCode,
  children,
}: {
  moduleCode: string;
  children: ReactNode;
}) {
  const { data: visibility = {}, isLoading } = usePublicModuleVisibility();
  if (isLoading && visibility[moduleCode] === undefined) {
    return <LoadingState label="Verificando disponibilidad" />;
  }
  if (!isPublicModuleEnabled(visibility, moduleCode)) {
    return (
      <section className="section container">
        <EmptyState
          title="Sección temporalmente no disponible"
          description="La Municipalidad ocultó esta sección mientras actualiza su contenido o servicio."
        />
      </section>
    );
  }
  return children;
}
